var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFinancialPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C99A6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    transform: "translate(2.945 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    className: "st0",
    d: "M13.9,157.9c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C17,156.5,15.6,157.9,13.9,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    className: "st0",
    d: "M13.9,126.2c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C17,124.8,15.6,126.2,13.9,126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st0",
    d: "M13.9,110.4c-1.7,0-3.1-1.4-3.1-3.1V21.9c0-5,4.1-9.1,9.1-9.1c0,0,0,0,0,0h108.5 c5,0,9.1,4.1,9.1,9.1c0,0,0,0,0,0v44.8c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1V21.9c0-1.6-1.3-2.9-2.9-2.9H19.9 c-1.6,0-2.9,1.3-2.9,2.9v85.4C17,109,15.6,110.4,13.9,110.4L13.9,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "st0",
    d: "M13.9,142.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C17,140.7,15.6,142.1,13.9,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "st0",
    d: "M93.7,168H77.5c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1l0,0h16.3c1.7,0,3.1,1.4,3.1,3.1 C96.8,166.6,95.4,168,93.7,168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "st0",
    d: "M181.6,189.5h-80.1c-6,0-10.8-4.9-10.8-10.8V74.4c0-6,4.9-10.8,10.8-10.8h80.1 c6,0,10.8,4.9,10.8,10.8v104.2C192.5,184.6,187.6,189.5,181.6,189.5z M101.5,69.8c-2.6,0-4.6,2.1-4.6,4.6v104.2 c0,2.6,2.1,4.6,4.6,4.6h80.1c2.6,0,4.6-2.1,4.6-4.6V74.4c0-2.6-2.1-4.6-4.6-4.6H101.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    transform: "translate(6.553 7.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    transform: "translate(18.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    className: "st0",
    d: "M92.6,30.7H52.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h40.3c1.7,0,3.1,1.4,3.1,3.1 C95.7,29.3,94.3,30.7,92.6,30.7L92.6,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    className: "st0",
    d: "M92.6,49.5H52.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h40.3c1.7,0,3.1,1.4,3.1,3.1 C95.7,48.1,94.3,49.5,92.6,49.5L92.6,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    className: "st0",
    d: "M68.5,68.2H52.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h16.2c1.7,0,3.1,1.4,3.1,3.1 C71.6,66.8,70.2,68.2,68.5,68.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    transform: "translate(0 22.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st0",
    d: "M72.6,64.6H23.8c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h48.8c1.7,0,3.1,1.4,3.1,3.1 C75.7,63.2,74.4,64.5,72.6,64.6C72.7,64.6,72.6,64.6,72.6,64.6L72.6,64.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    transform: "translate(1.989 0.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    className: "st0",
    d: "M50.2,57.9c-1.1,0.7-2.3,1.2-3.5,1.4c-1.5,0.4-3.1,0.6-4.7,0.5c-1.9,0-3.8-0.3-5.6-0.9 c-1.5-0.5-3-1.4-4.2-2.4c-1.2-1-2.1-2.2-2.9-3.6c-0.7-1.4-1.3-2.8-1.7-4.3h-3.9l1.3-4h2.1c0-0.2,0-0.3,0-0.5v-1.5 c0-0.4,0-0.7,0-1.1c0-0.4,0-0.7,0.1-1.1h-3.3l1.4-4h2.6c0.4-1.6,1.1-3.2,2.1-4.6c0.9-1.3,2-2.5,3.2-3.5c1.3-1,2.7-1.8,4.3-2.2 c1.7-0.5,3.4-0.8,5.2-0.8c1.4,0,2.8,0.1,4.2,0.4c1.1,0.2,2.2,0.6,3.2,1.1l-1.8,4.6c-0.8-0.5-1.7-0.8-2.6-1 c-1.1-0.2-2.2-0.3-3.3-0.3c-0.9,0-1.9,0.2-2.8,0.4c-0.9,0.3-1.8,0.7-2.6,1.2c-0.8,0.5-1.5,1.2-2.1,1.9c-0.6,0.8-1.1,1.7-1.4,2.7 h13.4l-1.3,4h-13c-0.1,0.8-0.2,1.5-0.2,2.3v1c0,0.2,0,0.4,0,0.5c0,0.2,0,0.3,0.1,0.5h11.9l-1.2,4h-10c0.2,0.9,0.6,1.7,1.1,2.4 c0.5,0.8,1.2,1.4,1.9,2c0.8,0.6,1.7,1,2.6,1.3c1.1,0.3,2.2,0.5,3.3,0.5c2.1,0.1,4.2-0.5,6.1-1.6L50.2,57.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    transform: "translate(31.776 20.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "st0",
    d: "M149.8,169.3H69.7c-6,0-10.8-4.9-10.8-10.8V54.2c0-6,4.9-10.8,10.8-10.8h80.1 c6,0,10.8,4.9,10.8,10.8v104.2C160.7,164.4,155.8,169.2,149.8,169.3z M69.7,49.6c-2.6,0-4.6,2.1-4.6,4.6v104.2 c0,2.6,2.1,4.6,4.6,4.6h80.1c2.6,0,4.6-2.1,4.6-4.6V54.2c0-2.6-2.1-4.6-4.6-4.6H69.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    transform: "translate(5.026 4.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    className: "st0",
    d: "M139.9,74.9H69.6c-1.7,0-3.1-1.4-3.1-3.1v-18c0-1.7,1.4-3.1,3.1-3.1h70.3 c1.7,0,3.1,1.4,3.1,3.1v18C143,73.5,141.7,74.8,139.9,74.9C140,74.9,140,74.9,139.9,74.9z M72.7,68.7h64.1V56.9H72.7V68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "st0",
    d: "M85.2,101.5H69.6c-1.7,0-3.1-1.4-3.1-3.1V82.3c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C88.3,100.1,87,101.4,85.2,101.5z M72.7,95.3h9.5v-9.9h-9.5V95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st0",
    d: "M112.6,101.5H96.9c-1.7,0-3.1-1.4-3.1-3.1V82.3c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C115.7,100.1,114.3,101.4,112.6,101.5z M100,95.3h9.5v-9.9H100V95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "st0",
    d: "M139.9,101.5h-15.6c-1.7,0-3.1-1.4-3.1-3.1V82.3c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C143,100.1,141.6,101.4,139.9,101.5z M127.4,95.3h9.5v-9.9h-9.5V95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st0",
    d: "M85.2,126.9H69.6c-1.7,0-3.1-1.4-3.1-3.1v-16.1c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C88.3,125.5,87,126.9,85.2,126.9z M72.7,120.7h9.5v-9.9h-9.5V120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "st0",
    d: "M112.6,126.9H96.9c-1.7,0-3.1-1.4-3.1-3.1v-16.1c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C115.7,125.5,114.3,126.9,112.6,126.9z M100,120.7h9.5v-9.9H100V120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    className: "st0",
    d: "M85.2,152.3H69.6c-1.7,0-3.1-1.4-3.1-3.1v-16.1c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C88.3,150.9,87,152.3,85.2,152.3z M72.7,146.1h9.5v-9.9h-9.5V146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    className: "st0",
    d: "M112.6,152.3H96.9c-1.7,0-3.1-1.4-3.1-3.1v-16.1c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v16.1C115.7,150.9,114.3,152.3,112.6,152.3z M100,146.1h9.5v-9.9H100V146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    className: "st0",
    d: "M139.9,152.3h-15.6c-1.7,0-3.1-1.4-3.1-3.1v-41.5c0-1.7,1.4-3.1,3.1-3.1h15.6 c1.7,0,3.1,1.4,3.1,3.1v41.5C143,150.9,141.6,152.3,139.9,152.3z M127.4,146.1h9.5v-35.3h-9.5V146.1z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    transform: "translate(0 36.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    className: "st0",
    d: "M72.9,153.1H17.2c-6,0-10.9-4.9-10.9-10.9V142c0-6,4.9-10.9,10.9-10.9h55.6 c6,0,10.9,4.9,10.9,10.9v0.3C83.7,148.2,78.9,153.1,72.9,153.1z M17.2,137.3c-2.6,0-4.7,2.1-4.7,4.7c0,0,0,0,0,0v0.3 c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h55.6c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0V142c0-2.6-2.1-4.7-4.7-4.7c0,0,0,0,0,0H17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    className: "st0",
    d: "M72.9,137.3H17.2c-6,0-10.9-4.9-10.9-10.9v-0.3c0-6,4.9-10.9,10.9-10.9h55.6 c6,0,10.9,4.9,10.9,10.9v0.3C83.7,132.4,78.9,137.3,72.9,137.3z M17.2,121.5c-2.6,0-4.7,2.1-4.7,4.7c0,0,0,0,0,0v0.3 c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h55.6c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-0.3c0-2.6-2.1-4.7-4.7-4.7c0,0,0,0,0,0H17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    className: "st0",
    d: "M72.9,121.5H17.2c-6,0-10.9-4.9-10.9-10.9v-0.3c0-6,4.9-10.9,10.9-10.9h55.6 c6,0,10.9,4.9,10.9,10.9v0.3C83.7,116.6,78.9,121.5,72.9,121.5z M17.2,105.7c-2.6,0-4.7,2.1-4.7,4.7c0,0,0,0,0,0v0.3 c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h55.6c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-0.3c0-2.6-2.1-4.7-4.7-4.7c0,0,0,0,0,0H17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    className: "st0",
    d: "M72.9,105.7H17.2c-6,0-10.9-4.9-10.9-10.9v-0.3c0-6,4.9-10.9,10.9-10.9h55.6 c6,0,10.9,4.9,10.9,10.9v0.3C83.7,100.8,78.9,105.7,72.9,105.7z M17.2,89.8c-2.6,0-4.7,2.1-4.7,4.7c0,0,0,0,0,0v0.3 c0,2.6,2.1,4.7,4.7,4.7c0,0,0,0,0,0h55.6c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-0.3c0-2.6-2.1-4.7-4.7-4.7c0,0,0,0,0,0H17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    className: "st0",
    d: "M72.9,89.8H17.2c-6,0-10.9-4.9-10.9-10.8v-0.3c0-6,4.9-10.9,10.9-10.9h55.6 c6,0,10.9,4.9,10.9,10.9V79C83.7,85,78.9,89.8,72.9,89.8z M17.2,74c-2.6,0-4.7,2.1-4.7,4.7c0,0,0,0,0,0V79c0,2.6,2.1,4.7,4.7,4.7 c0,0,0,0,0,0h55.6c2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0v-0.3c0-2.6-2.1-4.7-4.7-4.7c0,0,0,0,0,0H17.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinancialPlanning);
export default __webpack_public_path__ + "static/media/Icon_Financial_planning.7ef0e65336ccb545dded18bb7054c953.svg";
export { ForwardRef as ReactComponent };